export function onFormError(form, errors) {
    errors.forEach((error) => form.setError(error.path.join('.'), {
        type: 'manual',
        message: getMessage(error),
    }));
}
export const getMessage = function (error) {
    if (error.code === 'inUse') {
        return `${error.path.slice(-1)[0]} is already in use`;
    }
    if (error.code === 'invalid') {
        return `${error.path.slice(-1)[0]} is invalid`;
    }
    if (error.code === 'invalidEmail') {
        return `email is invalid`;
    }
    if (error.code === 'invalidPattern') {
        return `${error.path.slice(-1)[0]} is invalid`;
    }
    if (error.code === 'invalidDateFormat') {
        return `Format does not match ${error.attributes?.date}`;
    }
    if (error.code === 'notEnabled') {
        return `account is not enabled`;
    }
    if (error.code === 'notFound') {
        return `${error.path.slice(-1)[0]} was not found`;
    }
    if (error.code === 'overMax') {
        return `${error.path.slice(-1)[0]} was over the max ${error.attributes?.max}`;
    }
    if (error.code === 'required') {
        return `${error.path.slice(-1)[0]} is required`;
    }
    if (error.code === 'requiresAfter') {
        return `${error.path.slice(-1)[0]} is not after ${error.attributes?.date}`;
    }
    if (error.code === 'requiresBefore') {
        return `${error.path.slice(-1)[0]} is not before ${error.attributes?.date}`;
    }
    if (error.code === 'requiresDigits') {
        return `${error.path.slice(-1)[0]} must only contain digits`;
    }
    if (error.code === 'requiresFalse') {
        return `${error.path.slice(-1)[0]} must be false`;
    }
    if (error.code === 'requiresFuture') {
        return `${error.path.slice(-1)[0]} must be in the future`;
    }
    if (error.code === 'requiresFutureOrPresent') {
        return `${error.path.slice(-1)[0]} must be in the present or future`;
    }
    if (error.code === 'requiresNegative') {
        return `${error.path.slice(-1)[0]} must be negative`;
    }
    if (error.code === 'requiresNegativeOrZero') {
        return `${error.path.slice(-1)[0]} must be negative or zero`;
    }
    if (error.code === 'requiresNull') {
        return `${error.path.slice(-1)[0]} must be null`;
    }
    if (error.code === 'requiresPast') {
        return `${error.path.slice(-1)[0]} must be in the past`;
    }
    if (error.code === 'requiresPastOrPresent') {
        return `${error.path.slice(-1)[0]} must be in the past or present`;
    }
    if (error.code === 'requiresPositive') {
        return `${error.path.slice(-1)[0]} must be positive`;
    }
    if (error.code === 'requiresPositiveOrZero') {
        return `${error.path.slice(-1)[0]} must be positive or zero`;
    }
    if (error.code === 'requiresSize') {
        return `${error.path.slice(-1)[0]} requires size ${error.attributes?.size}`;
    }
    if (error.code === 'requiresTrue') {
        return `${error.path.slice(-1)[0]} must be true`;
    }
    if (error.code === 'requiresUnverified') {
        return `Account is already verified`;
    }
    if (error.code === 'underMin') {
        return `${error.path.slice(-1)[0]} was under the minimum ${error.attributes?.min}`;
    }
    return error.code;
};
